import DialogSeasonalReservation from "./DialogSeasonalReservation";

export default {
    name     : 'dialog_seasonal_reservation_text',
    component: DialogSeasonalReservation,
    dialog   : {
        'max-width': "700px",
        'persistent': true
    }
}
